import { render, staticRenderFns } from "./VolunteerProgramSettings.vue?vue&type=template&id=57ffa859"
import script from "./VolunteerProgramSettings.vue?vue&type=script&lang=js"
export * from "./VolunteerProgramSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports